import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core'

@Directive({
  selector: '[appClickOutside]',
  standalone: true
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<void>()
  constructor(private el: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    const target = event.target as HTMLElement

    // DEBUG
    // console.log('doc click', target)
    if (!this.el.nativeElement.contains(event.target)) {
      this.clickOutside.emit()
    }
  }
}
